import { VoiceId, Voice, voices } from "@/data/voices";
export const decryptValue = (encryptedValue: string): string => {
  const encryptionKey = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;
  if (!encryptionKey) {
    throw new Error(
      "NEXT_PUBLIC_ENCRYPTION_KEY is not set in the environment variables.",
    );
  }
  try {
    const decoded = atob(encryptedValue); // Decode from base64
    let decrypted = "";
    for (let i = 0; i < decoded.length; i++) {
      decrypted += String.fromCharCode(
        decoded.charCodeAt(i) ^
          encryptionKey.charCodeAt(i % encryptionKey.length),
      );
    }
    // Remove non-printable characters and trim white spaces
    return decrypted.replace(/[^\x20-\x7E]/g, "").trim();
  } catch (error) {
    throw new Error(
      "Failed to decrypt the value. Ensure the encrypted string is valid.",
    );
  }
};

// Utility to safely access URL search parameters
export const getQueryParam = (param: string): string => {
  if (typeof window === "undefined") return ""; // Prevent SSR errors
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param) || "";
};

export function getCurrentUTCDateTime() {
  // Create a new Date object
  var now = new Date();
  // Get the UTC components
  var utcYear = now.getUTCFullYear();
  var utcMonth = String(now.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  var utcDate = String(now.getUTCDate()).padStart(2, "0");
  var utcHours = String(now.getUTCHours()).padStart(2, "0");
  var utcMinutes = String(now.getUTCMinutes()).padStart(2, "0");
  var utcSeconds = String(now.getUTCSeconds()).padStart(2, "0");
  // Combine components into the desired format
  return `${utcYear}-${utcMonth}-${utcDate} ${utcHours}:${utcMinutes}:${utcSeconds}`;
}

export function getUrlBasedOnEnv(input: string): string {
  if (input.includes("staging")) {
    return process.env.NEXT_PUBLIC_STAGE as string;
  } else if(input.includes("uat")){
    return process.env.NEXT_PUBLIC_DEV as string;  // UAT API is showing some issue from DEV OPS side, so using DEV API for UAT
  } else if (input.includes("development")) {
    return process.env.NEXT_PUBLIC_DEV as string;
  } else if (input.includes("reports")) {
    return process.env.NEXT_PUBLIC_REPORTS as string;
  } else {
    return process.env.NEXT_PUBLIC_LIVE as string;
  }
}

export function getVoiceFromId(id: string | null | undefined): Voice {
  let voiceId: VoiceId;

  switch (id) {
    case "alloy":
      voiceId = VoiceId.alloy;
      break;
    case "ash":
      voiceId = VoiceId.ash;
      break;
    case "ballad":
      voiceId = VoiceId.ballad;
      break;
    case "coral":
      voiceId = VoiceId.coral;
      break;
    case "echo":
      voiceId = VoiceId.echo;
      break;
    case "sage":
      voiceId = VoiceId.sage;
      break;
    case "shimmer":
      voiceId = VoiceId.shimmer;
      break;
    case "verse":
      voiceId = VoiceId.verse;
      break;
    default:
      voiceId = VoiceId.shimmer;
  }

  return voices.find((voice) => voice.id === voiceId)!;
}